import { render, staticRenderFns } from "./insCode.vue?vue&type=template&id=1f912224&"
import script from "./insCode.vue?vue&type=script&lang=js&"
export * from "./insCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports